import { OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { OverlayService } from './overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@app/core/language/language.service';
export var TYPES_LOADING = {
    'GENERIC': 'generic',
    'PROGRESS': 'progress',
    'SPINNER': 'spinner'
};
export var TYPES_MODE_LOADING = {
    'DETERMINATE': 'determinate',
    'INDETERMINATE': 'indeterminate'
};
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent(vcRef, overlayService, translate, languageService) {
        if (translate === void 0) { translate = null; }
        this.vcRef = vcRef;
        this.overlayService = overlayService;
        this.translate = translate;
        this.languageService = languageService;
        this.type = TYPES_LOADING.GENERIC;
        this.value = 0;
        this.mode = TYPES_MODE_LOADING.INDETERMINATE;
        this.showHeader = true;
        this.backdropEnabled = false;
        this.positionGloballyCenter = false;
        /** FIXME: Não deveria ser necessário usar o @ngx-translate da forma abaixo.
        Voltamos o codigo anterior, agora refatorado, ja que alguns componentes nao sao traduzidos sem ele
        */
        translate.addLangs(this.languageService.getSiteLanguageCodes());
        translate.use(this.languageService.siteLanguage);
    }
    LoadingComponent.prototype.ngOnInit = function () {
        this.bootstrapLoading();
        this.configOverlay();
    };
    LoadingComponent.prototype.ngDoCheck = function () {
        // Based on status of showLoading attach/detach overlay to progress spinner template
        if (this.showLoading && !(this.overlayRef && this.overlayRef.hasAttached())) {
            if (this.progressSpinnerRef && this.vcRef) {
                this.overlayService.attachTemplatePortal(this.overlayRef, this.progressSpinnerRef, this.vcRef);
            }
        }
        else if (!this.showLoading && this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
        }
    };
    LoadingComponent.prototype.bootstrapLoading = function () {
        var values = Object.keys(TYPES_LOADING).map(function (e) { return TYPES_LOADING[e]; });
        if (!values.includes(this.type)) {
            return this.type = TYPES_LOADING.GENERIC;
        }
        if (this.type !== TYPES_LOADING.GENERIC) {
            this.showHeader = false;
            this.backdropEnabled = true;
            this.positionGloballyCenter = true;
        }
        if (this.type === TYPES_LOADING.PROGRESS) {
            this.mode = TYPES_MODE_LOADING.DETERMINATE;
        }
    };
    LoadingComponent.prototype.configOverlay = function () {
        // Config for Overlay Service
        this.progressSpinnerOverlayConfig = {
            hasBackdrop: this.backdropEnabled
        };
        if (this.positionGloballyCenter) {
            this.progressSpinnerOverlayConfig['positionStrategy'] = this.overlayService.positionGloballyCenter();
        }
        // Create Overlay for progress spinner
        this.overlayRef = this.overlayService.createOverlay(this.progressSpinnerOverlayConfig);
    };
    return LoadingComponent;
}());
export { LoadingComponent };
